module.exports = "$str = '<ul>';\nforeach ($talks as $talk) {\n  $str += '<li>' . $talk->name . '</li>';\n}\n$str += '</ul>';"


//////////////////
// WEBPACK FOOTER
// ./src/slides/05_history/php.example
// module id = 1491
// module chunks = 0